module.exports = __webpack_public_path__ + "img/collection-memoireRingsPlatinum@2x.91395f4.jpg";